export default __webpack_public_path__ + "static/media/kniv-bur.4cbc2954.jpg";